import { Component } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class ApartmentsOverviewNoticeBlock extends BaseBlock {
	get notice() {
		return this.getText('notice').split(';');
	}
}

export default ApartmentsOverviewNoticeBlock;
